import React, { useEffect, useState, useRef } from "react";
import {
  Autocomplete,
  Card,
  Typography,
  TextField,
  Box,
  Popper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Close, Search, ChevronRight } from "@mui/icons-material";
import { connect } from "react-redux";
import { homeActions } from "actions";
import { useHistory } from "react-router-dom";
import { handleProductSelect } from "pages/home/CommonFunctions";

const SearchMedicationAutoComplete = (props) => {
  const {
    productsSearchList,
    productsSearchListisProgress,
    productsSearchListisSuccess,
    recentList,
    getRecentSearch,
    selectedProduct,
    customPopperView,
    getProductPartialSearch,
    selectedInsurance,
    saveSelectedProduct,
    resetData,
    changeView,
    searchOnFocus,
    zIndex,
    openList,
    isFromHomeGauge,
    match,
    viewType,
    setGaugeInit,
    savedevicelocation,
    setCurrentLocation,
    topProductsList,
    organizationInfo,
  } = props;
  const history = useHistory();
  const searchAutoCompleteRef = useRef(null);

  const [searchValue, setSearchValue] = useState("");
  const [selectedDropdownValue, setSelectedDropdownValue] = useState("");
  const [showDefaultList, setShowDefaultList] = useState(openList || false);
  const [myOptions, setMyOptions] = useState([]);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
   const isHCPTemplate =
     organizationInfo?.type?.toLowerCase() === "h" &&
     organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  useEffect(() => {
    if (selectedProduct || match?.params?.name) {
      setShowDefaultList(false);
      searchOnFocus && searchOnFocus("gauge");
    } else {
      handleOnFocus();
    }
    updateInitialOptions();
  }, []);

  useEffect(() => {
    if (productsSearchList && productsSearchList.length) {
      const products = productsSearchList.map((option) => {
        return {
          groupTitle: "Select from below:",
          ...option,
        };
      });
      setMyOptions(products);
    }
  }, [productsSearchList]);

  const productSearch = (event) => {
    if (!showDefaultList) {
      setShowDefaultList(true);
    }
    setSearchValue(event.target.value);
    if (event?.target?.value && event.target.value.length > 2) {
      getProductPartialSearch(event.target.value);
    }
  };

  const getSelectedOption = (item) => {
    setSelectedDropdownValue("");
    if (item) {
      const params = {
        item,
        selectedInsurance,
        saveSelectedProduct,
        resetData,
        history,
        changeView,
        isFromHomeGauge,
        savedevicelocation,
        setCurrentLocation,
      };
      if (
        (selectedProduct &&
          selectedProduct.id !== item.id &&
          selectedProduct.productId !== item.productId) ||
        selectedProduct === ""
      ) {
        setGaugeInit(true);
        handleProductSelect(params);
      }

      searchOnFocus && searchOnFocus("gauge");
      setShowDefaultList(false);
      searchAutoCompleteRef.current.blur();
      setSelectedDropdownValue(item);
    }
  };

  useEffect(() => {
    if (match?.params?.name && productsSearchList?.length) {
      getSelectedOption(productsSearchList[0]);
    } else if (
      productsSearchListisSuccess &&
      match?.params?.name &&
      !productsSearchListisProgress &&
      productsSearchList?.length === 0
    ) {
      history.push("/");
    }
  }, [productsSearchList]);

  useEffect(() => {
    if (
      (recentList && recentList.length) ||
      (topProductsList && topProductsList.length)
    ) {
      updateInitialOptions();
    }
  }, [recentList, topProductsList]);

  const handleOnFocus = () => {
    getRecentSearch();
    if (!showDefaultList) {
      setShowDefaultList(true);
    }
    searchOnFocus && searchOnFocus("showList");
  };

  const PopperView = (prop) => {
    return (
      <Popper
        {...prop}
        className={`search-medication-popper-view ${
          matches && isHCPTemplate ? "search-medication-popper-view-small" : ""
        }`}
        style={{ width: matches ? "80%" : "480px" }}
        placement="bottom"
      />
    );
  };

  const updateInitialOptions = () => {
    let result = [];

    const recent =
      recentList &&
      recentList.map((option) => {
        return {
          groupTitle: "Recent Searches:",
          ...option,
        };
      });
    const top = topProductsList?.map((option) => {
      return {
        groupTitle: "Top Searches:",
        ...option,
      };
    });
    result = [...recent, ...top];
    setMyOptions(result);
  };

  return (
    <Card
      className="mobile-search-container"
      sx={{
        zIndex: zIndex,
        width: matches ? "80%" : "30rem",
        marginLeft: matches ? 0 : "-15rem",
        position: "absolute",
        left: matches ? "10%" : "50%",
        top: viewType === "insurance" ? 0 : "-36px",
      }}
    >
      <Autocomplete
        autoHighlight
        value={selectedProduct || selectedDropdownValue}
        // ref={searchAutoCompleteRef}
        open={showDefaultList}
        options={myOptions}
        groupBy={(option) => option.groupTitle}
        getOptionLabel={(option) =>
          option.productName || option.aliasName || ""
        }
        className="auto-complete-input"
        PopperComponent={customPopperView || PopperView}
        onFocus={handleOnFocus}
        // onBlur={() => searchOnFocus("gauge")}
        // blurOnSelect={true}
        clearIcon={
          <Close
            fontSize="small"
            onClick={() => {
              history.push("/");
            }}
          />
        }
        filterOptions={(all) => {
          return all;
        }}
        onChange={(event, newInputValue) => {
          getSelectedOption(newInputValue);
        }}
        // eslint-disable-next-line no-unused-vars
        renderOption={(props, option, { inputValue }) => {
          let optionName = "";
          const name = option.productName || option.aliasName;
          if (name) {
            const pattern = /inputValue/gi;
            optionName = name.replace(pattern, (match) => `<b>${match}</b>`);
          }
          return (
            <Box
              {...props}
              className="auto-complete-list-container"
              key={option.id}
              onClick={() => getSelectedOption(option)}
            >
              <Box
                {...props}
                className="search-list-view"
                dangerouslySetInnerHTML={{ __html: optionName }}
              ></Box>
              <ChevronRight className="right-icon" />
            </Box>
          );
        }}
        renderInput={(params) => (
          <Box>
            <Typography variant="h3LatoBold" sx={{ color: "#003843" }}>
              Enter a medication:
            </Typography>
            <Box sx={{ position: "relative" }} mt={1}>
              <TextField
                {...params}
                variant="standard"
                // autoFocus={showDefaultList}
                inputRef={searchAutoCompleteRef}
                value={searchValue}
                // placeholder="Type your drug"
                onChange={productSearch}
              />
              <Search
                sx={{
                  color: `${organizationInfo?.colorSchemeJson?.primaryButtonColor} !important`,
                }}
                className="search-icon"
              />
            </Box>
          </Box>
        )}
      />
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedProduct: state.home.selectedProduct,
    selectedInsurance: state.insuranceList.selectedInsurance,
    productsSearchList: state.productSearchList.data,
    productsSearchListisProgress: state.productSearchList.isProgress,
    productsSearchListisSuccess: state.productSearchList.success,
    topProductsList: state.topProducts.data || [],
    recentList: state.recentSearch.data || [],
    isProgress: state.topProducts.isProgress,
    organizationInfo: state.organizationInfo.data || {},
  };
};

const mapDispatchToProps = {
  getRecentSearch: () => homeActions.getRecentSearchList(),
  getProductPartialSearch: (value) =>
    homeActions.getProductPartialSearch(value),
  saveSelectedProduct: (value) => homeActions.saveSelectedProduct(value),
  resetData: (value) => homeActions.resetData(value),
  savedevicelocation: (value) => homeActions.savedevicelocation(value),
  setCurrentLocation: (value) => homeActions.setCurrentLocation(value),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchMedicationAutoComplete);
